
cc.Class({
    extends: cc.Component,

    properties: {
        skeleton: sp.Skeleton
    },

    onLoad () {
        this.skeleton.setCompleteListener((event) => {
            if (event.animation.name === 'start') {
                this.node.emit('spawned');
            }
        });
    },

    idle () {
        this.skeleton.setAnimation(0, 'idle', true);
    },
    match () {
        this.skeleton.setAnimation(0, 'match', false);
    },
    fly () {
        this.skeleton.setAnimation(0, 'reposition', false);
        this.skeleton.addAnimation(0, 'idle', true);
    },
    spawn () {
        this.skeleton.setSkin('gold');
        this.skeleton.setAnimation(0, 'flash', false);
        this.skeleton.addAnimation(0, 'idle3', true);

        return new Promise((resolve) => {
            this.node.once('spawned', resolve);
        });
    },
    kill () {
        this.skeleton.setAnimation(0, 'end', false);
    },

    stamp () {
        this.skeleton.addAnimation(0, 'idle', true);
    },
});
